"use strict";

import "./Filter.css";
import React from "react";
import TextFilter from "vwa/components/TextFilter";
import Pin from "vwa/components/Pin";
import ButtonGroup from "vwa/components/ButtonGroup";
import Button from "vwa/components/Button"
import lang from "vwa/lang";

export default class Filter extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			expanded: false
		};
	}
	
	toggle() {
		this.setState({
			expanded: !this.state.expanded
		});
	}
	
	render() {
		
		const pin = this.props.pinStatus > 0;
		const pinAll = this.props.pinStatus == 2;
		const className = this.state.expanded ? "" : "Hidden";
		
		return (
			<div className="Filter">
				<div>
					<TextFilter onSubmit={value => this.props.onFilter({text: value})} value={this.props.filterExpression.text}/>
					<Pin onChange={value => this.props.onPinChange(value)} checked={pin} indeterminate={!pinAll} useForAll/>
				</div>
				<div className={className}>
					<ButtonGroup onChange={id => this.props.onFilter({type: id})} selected={this.props.filterExpression.type}>
						<Button id="PolygonalPOI" className="Light">{lang.POLYGONAL}</Button>
						<Button id="RadialPOI" className="Light">{lang.RADIAL}</Button>
					</ButtonGroup>
				</div>
				<footer onClick={_ => this.toggle()}>&bull;&bull;&bull;</footer>
			</div>
		);
	}
	
}

Filter.propTypes = {
	pinStatus: React.PropTypes.number,
	filterExpression: React.PropTypes.shape({
		text: React.PropTypes.string,
		type: React.PropTypes.string
	}),
	onFilter: React.PropTypes.func,
	onPinChange: React.PropTypes.func
};

Filter.defaultProps = {
	onFilter: expression => {},
	onPinChange: value => {},
	pinStatus: 2
};


// WEBPACK FOOTER //
// ./src/view/POIList/Filter/Filter.jsx